module.exports = __webpack_public_path__ + "img/footer-background-small.e256eee9.jpg";